export const climateStressTestToTableParser = (data, scenario = 'orderly') =>
  data.map((item) => [
    [item.id, scenario],
    [item, scenario],
    [item.country, scenario],
    [item.industry, scenario],
    [item, scenario],
    [item, scenario],
    [item, scenario],
    [item, scenario],
  ]);

export const changeScenario = (data, scenario) =>
  data.map((entity) => entity.map((columns) => [columns[0], scenario]));
